<template>
  <Slide class="ProspectDetailsSupportSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <InputFields @input="doUpdateField" @change="doUpdateField">
      <TextInput v-if="fieldConfig.firstName.present"
        name="firstName"
        :title="content.firstNameLabel"
        :value="fieldValues.firstName"
        :error="fieldErrors.firstName"
        :optional="!fieldConfig.firstName.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.lastName.present"
        name="lastName"
        :title="content.lastNameLabel"
        :value="fieldValues.lastName"
        :error="fieldErrors.lastName"
        :optional="!fieldConfig.lastName.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.company.present"
        name="company"
        :title="content.companyLabel"
        :value="fieldValues.company"
        :error="fieldErrors.company"
        :optional="!fieldConfig.company.required"
        :disabled="!isCurrentSlide"
      />
    </InputFields>
  </Slide>
</template>

<script>
import { inputFieldsSlideMixin } from '../util/slideBuilders.js'

import InputFields from './elems/InputFields.vue'
import RegionInput from './elems/RegionInput.vue'
import Slide from './elems/Slide.vue'
import TextInput from './elems/TextInput.vue'

export default {
  mixins: [inputFieldsSlideMixin],
  components: {
    InputFields,
    RegionInput,
    Slide,
    TextInput,
  },
  computed: {
    fieldConfig() {
      return {
        firstName: {
          present: true,
          required: true,
        },
        lastName: {
          present: true,
          required: true,
        },
        company: {
          present: true,
          required: true,
        },
      }
    },
  },
}
</script>
